
class UrlEncryptionService {

    constructor(){
        this.secretKey = 'N4xQ8vLm2ZpR7cTy1HsK';
        this.signature = this.secretKey.split('');
    }

    encryptData(data) {
        if(!!data) {
            data = data.toString();
            let encrypted = '';
            for (let i = 0; i < data.length; i++) {
                let dataChar = data[i];
                let keyChar = this.signature[dataChar];
                encrypted += keyChar;
            }
            let randomWordsArray = this.generateRandomWordsArray();
            encrypted = randomWordsArray[0] + encrypted + randomWordsArray[1];
            return encrypted;
        }
    };

    decryptData(encryptedData) {
        if(!!encryptedData) {
            encryptedData = encryptedData.slice(2);
            encryptedData = encryptedData.slice(0, -2);
            let decryptedString = '';
            for(let i = 0; i < encryptedData.length; i++) {
                let dataChar = encryptedData[i];
                decryptedString += this.signature.indexOf(dataChar);
            }
            return decryptedString;
        } else {
            return '';
        }
    };

    generateRandomWordsArray() {
        let returnString = '';
        for (let i = 0; i < 4; i++) {
            let randomIndex = Math.floor(Math.random() * this.signature.length);
            let charCode = this.signature[randomIndex];
            returnString += charCode;
        }
        return [returnString.slice(0 ,2), returnString.slice(2, 4)];
    }
}

export default UrlEncryptionService;